var _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _rect5, _path4, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedPresenterLightActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 60,
    viewBox: "0 0 102 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    transform: "translate(3 3)",
    fill: "#5C617C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 30,
    height: 40,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.5C26.6406 30.5 28 29.1641 28 27.5C28 25.8594 26.6406 24.5 25 24.5C23.3359 24.5 22 25.8594 22 27.5C22 29.1641 23.3359 30.5 25 30.5ZM27.0859 31.25H26.6875C26.1719 31.5078 25.6094 31.625 25 31.625C24.3906 31.625 23.8047 31.5078 23.2891 31.25H22.8906C21.1562 31.25 19.75 32.6797 19.75 34.4141V35.375C19.75 36.0078 20.2422 36.5 20.875 36.5H29.125C29.7344 36.5 30.25 36.0078 30.25 35.375V34.4141C30.25 32.6797 28.8203 31.25 27.0859 31.25Z",
    fill: "#6E7391"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 10,
    width: 50,
    height: 12,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16C68.0938 16 69 15.1094 69 14C69 12.9062 68.0938 12 67 12C65.8906 12 65 12.9062 65 14C65 15.1094 65.8906 16 67 16ZM68.3906 16.5H68.125C67.7812 16.6719 67.4062 16.75 67 16.75C66.5938 16.75 66.2031 16.6719 65.8594 16.5H65.5938C64.4375 16.5 63.5 17.4531 63.5 18.6094V19.25C63.5 19.6719 63.8281 20 64.25 20H69.75C70.1562 20 70.5 19.6719 70.5 19.25V18.6094C70.5 17.4531 69.5469 16.5 68.3906 16.5Z",
    fill: "#5C617C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 24,
    width: 50,
    height: 12,
    rx: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30C68.0938 30 69 29.1094 69 28C69 26.9062 68.0938 26 67 26C65.8906 26 65 26.9062 65 28C65 29.1094 65.8906 30 67 30ZM68.3906 30.5H68.125C67.7812 30.6719 67.4062 30.75 67 30.75C66.5938 30.75 66.2031 30.6719 65.8594 30.5H65.5938C64.4375 30.5 63.5 31.4531 63.5 32.6094V33.25C63.5 33.6719 63.8281 34 64.25 34H69.75C70.1562 34 70.5 33.6719 70.5 33.25V32.6094C70.5 31.4531 69.5469 30.5 68.3906 30.5Z",
    fill: "#5C617C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 50,
    height: 12,
    rx: 2,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 44C68.0938 44 69 43.1094 69 42C69 40.9062 68.0938 40 67 40C65.8906 40 65 40.9062 65 42C65 43.1094 65.8906 44 67 44ZM68.3906 44.5H68.125C67.7812 44.6719 67.4062 44.75 67 44.75C66.5938 44.75 66.2031 44.6719 65.8594 44.5H65.5938C64.4375 44.5 63.5 45.4531 63.5 46.6094V47.25C63.5 47.6719 63.8281 48 64.25 48H69.75C70.1562 48 70.5 47.6719 70.5 47.25V46.6094C70.5 45.4531 69.5469 44.5 68.3906 44.5Z",
    fill: "#5C617C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 59,
    stroke: "#5C617C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedPresenterLightActive);
export default __webpack_public_path__ + "static/media/featured-presenter-light-active.4dbedb1b6.svg";
export { ForwardRef as ReactComponent };